import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['section'];

  connect() {}

  toggle(event) {
    if (!this.hasSectionTarget) return;

    // Hide both sections
    this.sectionTargets.forEach((section) => section.classList.add('d-none'));

    // Show the target section
    const id = event.target.getAttribute('aria-controls');
    document.getElementById(id)?.classList?.remove('d-none');
  }
}
